// @flow
import { getCanonicalAlias } from '@finect/front-resources/Products';

const domain = 'www.finect.com';
const baseURL = `https://${domain}`;

export const getHomeCanonical = (productType: Object) => `${baseURL}/${productType.slug}`;
export const getCompanyCanonical = (productType: Object, company: Object) =>
  `${baseURL}/${productType.slug}/gestoras/${company.id}-${company.alias}`;

export const getManagementCompaniesCanonical = (productType: Object) => `${baseURL}/${productType.slug}/gestoras`;
export const getCategoriesCanonical = (productType: Object, category?: string | null) =>
  `${baseURL}/${productType.slug}/categoria${category ? `/${category}` : ''}`;

export const getStorefrontCanonical = (tag: Object) => `${baseURL}/invertir/${tag.alias}`;

export const getBankCanonical = (bank: Object) => `${baseURL}/bancos/${bank.alias}`;

export const getBankProductCanonical = (bank: Object, productType: Object) =>
  `${baseURL}/bancos/${bank.alias}/productos/${productType.slug}`;

// JSON-LD para un <script type="application/ld+json">. Helmet no escapa el contenido de los <script>, así
// que un `</script>` dentro de un nombre cerraría la etiqueta: `<` va como \u003c, que sigue siendo JSON válido
const toJsonLd = (schema: Object): string => JSON.stringify(schema).replace(/</g, '\\u003c');

/**
 * BreadcrumbList de schema.org que empieza en la portada: Inicio › …items. Cada item lleva su nombre y
 * su ruta desde la raíz (`/fondos-inversion`).
 */
export const getBreadcrumbSchemaORG = (items: Array<{ name: string, path: string }>): string =>
  toJsonLd({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{ name: 'Inicio', path: '' }, ...items].map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${baseURL}${item.path}`
    }))
  });

export const getItemListSchemaORG = (
  items: Array<Object>,
  productType: Object,
  listName: string,
  pageCanonical: string
) => {
  if (!items || !items.length) return null;

  const validItems = items.filter(fund => fund.isin && fund.alias && fund.name).slice(0, 10);

  if (!validItems.length) return null;

  return toJsonLd({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: listName,
    url: `${baseURL}${pageCanonical}`,
    itemListElement: validItems.map((fund, index) => {
      // List payloads don't expand classes — `getCanonicalAlias` falls back to fund.alias.
      const canonicalAlias = getCanonicalAlias(fund);
      return {
        '@type': 'ListItem',
        position: index + 1,
        url: `${baseURL}/${productType.slug}/${fund.isin}${canonicalAlias ? `-${canonicalAlias}` : ''}`,
        name: fund.name
      };
    })
  });
};
